var map = {
	"./act": 1510,
	"./act.tsx": 1510,
	"./gmat": 1511,
	"./gmat.tsx": 1511,
	"./gre": 1512,
	"./gre.tsx": 1512,
	"./ielts": 1513,
	"./ielts.tsx": 1513,
	"./ielts_general_training": 1514,
	"./ielts_general_training.tsx": 1514,
	"./lsat": 1515,
	"./lsat.tsx": 1515,
	"./mcat": 1516,
	"./mcat.tsx": 1516,
	"./sat": 1517,
	"./sat.tsx": 1517,
	"./toefl": 1518,
	"./toefl.tsx": 1518
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2530;
module.exports = webpackAsyncContext;